import {
  UPDATE_GALLERY_LOAD_MORE,
  IS_MOBILE,
  ON_RESTART_GALLERY,
  ON_CHANGE_FEED_GALLERY,
  ON_CHANGE_HASHTAG_GALLERY,
} from '../constants';

const GALLER_DEFAULT_STATE = {
  rowHeight: 0,
  countRowDisplay: 0,
  height: 0,
  padding: 0,
  isLoadedMore: false,
  isDispalyShowMoreBtn: true,
  isLoadingMore: false,
  heightShowMoreNeedToRemove: 0,
};

const initState = {
  feed: { ...GALLER_DEFAULT_STATE },
  hashtags: { ...GALLER_DEFAULT_STATE },
};

export default (state = initState, action) => {
  switch (action.type) {
    case IS_MOBILE:
      return {
        ...state,
        isMobile: action.payload,
      };
    case UPDATE_GALLERY_LOAD_MORE:
      return {
        ...state,
        ...action.payload,
      };
    case ON_RESTART_GALLERY:
      return {
        ...state,
        feed: {
          ...state.feed,
          ...GALLER_DEFAULT_STATE,
        },
        hashtags: {
          ...state.hashtags,
          ...GALLER_DEFAULT_STATE,
        },
      };
    case ON_CHANGE_FEED_GALLERY:
      return {
        ...state,
        feed: {
          ...state.feed,
          ...action.payload,
        },
      };
    case ON_CHANGE_HASHTAG_GALLERY:
      return {
        ...state,
        hashtags: {
          ...state.hashtags,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};
